import { Type } from 'class-transformer';
import { BookmarkGroupModel } from './bookmark.group.model';
import { ContentType } from 'src/app/story/models/content-type.enum';
import { BookmarkViewModeTag } from './bookmark-view-mode.enum';
import { BookmarkModuleAccessorLevel } from './bookmark-module-accessor-level.enum';

export class BookmarkModel {
  // Content
  id: string;
  type: ContentType = ContentType.Bookmark;
  sex: string;
  module_name?: string;

  // Metadata
  title: string;
  description: string;
  tags: string[];
  animated?: boolean;
  featured?: boolean;
  lowDefinition?: boolean;

  // App only utility properties, filtered from the `tags`
  tour?: boolean;
  quiz?: boolean;
  viewMode?: BookmarkViewModeTag;

  // Author
  author: string;
  author_first_name?: string;
  author_last_name?: string;

  // Audit
  create_date_time: Date;
  update_date_time?: Date;
  last_editor?: string;
  last_editor_first_name?: string;
  last_editor_last_name?: string;

  // Permissions
  @Type(() => BookmarkGroupModel)
  group_access?: BookmarkGroupModel[];
  is_owner?: boolean;

  // Cost
  cost?: number;
  premium?: boolean;

  // Embeds
  embed_url: string;
  embed_url_path: string;
  embedded: any;

  // Share
  share: any;
  share_url: string;

  // favorites
  favorite = false;

  // Images (legacy)
  icon: null;
  // thumbnail_url: string;
  thumbnail_url: string;
  hires_img_url?: string;
  rotatable_url?: string;

  // Stream
  stream: any;
  stream_url: string;

  // legacy/orphaned content
  unavailable = false;

  // Collections
  // NOTE: These properties are set from the response in
  // ws/organization/collection and represent data from the perspective of a
  // single collection, NOT all collections that a given bookmark may belong to.
  collection_content?: boolean;
  collection_content_id?: number;
  collection_content_createdate?: string;

  // Module accessibility: custom user "modules"
  module_accessor_level?: BookmarkModuleAccessorLevel;
  // Either the group or user id, depending on module_accessor_level
  module_accessor_id?: number;
  // Either the group title or "Custom" for user, depending on module_accessor_level
  module_accessor_title?: string;
}
